@if (resource) {
  <div class="relative w-full h-full group">
    <video
      #media
      class="block w-full h-full object-cover"
      [id]="id"
      [src]="resource.path | assets"
      [controls]="false"
      (loadedmetadata)="onLoadedMetadata()"
      (timeupdate)="onTimeUpdate()"
      (play)="onPlay()"
      (pause)="onPause()"
      (ended)="onEnd()"
      (mouseenter)="playOnHover ? play() : undefined"
      (mouseleave)="playOnHover ? stop() : undefined"></video>
    @if (controls) {
      <div
        class="absolute top-0 right-0 bottom-0 left-0 hidden group-hover:flex flex-col justify-end">
        <div class="flex items-center px-3 py-2 space-x-3 bg-slate-700/50">
          <p-button
            rounded
            raised
            size="large"
            [icon]="isPlaying ? 'pi pi-pause-circle' : 'pi pi-play-circle'"
            pTooltip="{{ isPlaying ? 'Pause' : 'Play' }}"
            (onClick)="togglePlayback()" />
          <div class="flex-1 px-2">
            <p-slider [(ngModel)]="progress" class="w-full"></p-slider>
          </div>
          <div class="text-slate-200">
            <span>
              {{ currentTime - startAt | formatSecondsToMinutes }} /
              {{ endAt - startAt | formatSecondsToMinutes }}
            </span>
          </div>
          <p-button
            rounded
            raised
            size="large"
            [icon]="isMuted ? 'pi pi-volume-off' : 'pi pi-volume-down'"
            pTooltip="{{ isMuted ? 'Unmute' : 'Mute' }}"
            (onClick)="toggleVolume()" />
        </div>
      </div>
    }
  </div>
} @else {
  <p-message icon="pi pi-file-excel" severity="warn" variant="simple">
    Resource not found
  </p-message>
}
